import React, { useEffect, useState } from 'react';
import { Trophy, ShieldCheck, Ticket } from 'lucide-react';
import { PRICE_ITEMS, CHECKOUT_URL } from '../mock';

function useCountdown(initialHours = 13, initialMinutes = 13, initialSeconds = 51) {
  const [t, setT] = useState({ h: initialHours, m: initialMinutes, s: initialSeconds });
  useEffect(() => {
    const iv = setInterval(() => {
      setT(prev => {
        let { h, m, s } = prev;
        if (s > 0) s--;
        else if (m > 0) { m--; s = 59; }
        else if (h > 0) { h--; m = 59; s = 59; }
        else { h = 23; m = 59; s = 59; }
        return { h, m, s };
      });
    }, 1000);
    return () => clearInterval(iv);
  }, []);
  return t;
}

export default function Pricing() {
  const t = useCountdown();
  const pad = (n) => String(n).padStart(2, '0');

  return (
    <section className="gradient-bg-light py-20">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-10">
          <p className="text-[#a020c9] tracking-widest text-sm font-semibold uppercase">— Não fique de fora —</p>
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-[#7a1fb0] mt-3">
            Para que você também viva tudo isso, preparamos uma oferta especial para você!
          </h2>
          <h3 className="font-heading font-black text-3xl md:text-4xl text-[#2b1039] mt-4">O caminho definitivo para o seu OURO!</h3>
          <p className="text-[#3a1450] mt-3">Junte-se à Academia de Pitágoras e garanta sua vantagem competitiva.</p>
          <div className="h-1 w-24 bg-[#ec2fd2] mx-auto mt-4 rounded"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-start">
          <div className="bg-white rounded-2xl p-8 shadow-xl">
            <h4 className="font-heading font-bold text-lg text-[#7a1fb0] mb-4 text-center">Valor REAL da Academia de Pitágoras!</h4>
            <ul className="price-list">
              {PRICE_ITEMS.map((it, i) => (
                <li key={i}>
                  <span className="text-[#3a1450] pr-3">{it.label}</span>
                  <span className="font-bold text-[#7a1fb0] whitespace-nowrap">{it.price}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6 text-center p-4 bg-[#f7ecff] rounded-lg">
              <div className="text-sm text-[#5a3a6b]">Valor total:</div>
              <div className="text-3xl font-black text-[#7a1fb0]">R$ 1.495,00</div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#a020c9] to-[#7a1fb0] rounded-2xl p-8 text-white shadow-2xl">
            <div className="flex items-center gap-3 mb-4">
              <Ticket size={24} />
              <span className="font-semibold">OFERTA ESPECIAL APLICADA</span>
            </div>
            <p className="uppercase tracking-widest text-sm text-white/85">O desconto acaba em:</p>
            <div className="flex items-center gap-2 justify-center my-4">
              <div className="bg-white/15 rounded px-4 py-3 min-w-[64px] text-center">
                <div className="text-3xl font-black">{pad(t.h)}</div>
                <div className="text-[10px] uppercase">horas</div>
              </div>
              <span className="text-2xl">:</span>
              <div className="bg-white/15 rounded px-4 py-3 min-w-[64px] text-center">
                <div className="text-3xl font-black">{pad(t.m)}</div>
                <div className="text-[10px] uppercase">min</div>
              </div>
              <span className="text-2xl">:</span>
              <div className="bg-white/15 rounded px-4 py-3 min-w-[64px] text-center">
                <div className="text-3xl font-black">{pad(t.s)}</div>
                <div className="text-[10px] uppercase">seg</div>
              </div>
            </div>

            <div className="bg-white/10 rounded-lg p-5 text-center">
              <div className="uppercase tracking-widest text-sm text-white/90 font-semibold">Desconto Especial</div>
              <p className="text-sm text-white/85 mt-1">Preço exclusivo que preparamos só para ti!</p>
              <div className="mt-3 text-white/70 line-through text-sm">De 12x de R$ 49,58 por:</div>
              <div className="mt-1 text-2xl font-black">12x de <span className="text-4xl">R$ 37,19</span></div>
              <div className="text-white/85 text-sm mt-1">ou <strong>R$ 360,00</strong> à vista</div>
            </div>

            <a href={CHECKOUT_URL} target="_blank" rel="noreferrer" className="btn-magenta w-full mt-6">
              QUERO ME TORNAR MEDALHISTA! <Trophy size={20} />
            </a>
            <p className="text-center text-white/85 text-xs mt-3 flex items-center justify-center gap-1">
              <ShieldCheck size={14} /> (7 dias de garantia incondicional)
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
